// extracted by mini-css-extract-plugin
export var section = "_4o-1";
export var topNav = "_4o-0";